// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader___GiON","loaderOuter":"PageOverlayLoader_loaderOuter__38B-_"};